import { createBrowserRouter, RouterProvider } from 'react-router-dom';
import { CssBaseline, ThemeProvider } from '@mui/material';
import { StyledEngineProvider } from '@mui/material/styles';
import { Toaster } from 'react-hot-toast';
import RTL from './components/RTL';
import useSettings from './hooks/useSettings';
import { createCustomTheme } from './theme';
import routes from './routes';
import './i18n';
import './base.css';
import { LicenseInfo } from '@mui/x-license';
import SettingsProvider from './contexts/settingsContext';
import { useEffect } from 'react';

LicenseInfo.setLicenseKey(
    `5b2c3bd2da6a68b0d802ecb241a3d884Tz0xMTEzNTEsRT0xNzc2MTI0Nzk5MDAwLFM9cHJvLExNPXN1YnNjcmlwdGlvbixQVj1RMy0yMDI0LEtWPTI=`
);

const App = () => {
    const router = createBrowserRouter(routes());

    useEffect(() => {
        if (sessionStorage.getItem(`tryReload`)) {
            setTimeout(() => {
                sessionStorage.removeItem(`tryReload`);
            }, 100000);
        }
    }, []);

    const AppContent = () => {
        const { settings } = useSettings();

        const theme = createCustomTheme({
            theme: settings.theme,
            direction: settings.direction as 'ltr' | 'rtl',
            responsiveFontSizes: settings.responsiveFontSizes,
        });

        return (
            <ThemeProvider theme={theme}>
                <RTL>
                    <CssBaseline />
                    <Toaster position="bottom-left" />
                    <RouterProvider router={router} />
                </RTL>
            </ThemeProvider>
        );
    };

    return (
        <StyledEngineProvider injectFirst>
            <SettingsProvider>
                <AppContent />
            </SettingsProvider>
        </StyledEngineProvider>
    );
};

export default App;
